import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Box, Button, Select, MenuItem, Typography, FormControl } from "@mui/material";

const HeaderCourse = () => {
  const [courses, setCourses] = useState([]); // Store all courses
  const [filteredCourses, setFilteredCourses] = useState([]); // Store filtered courses
  const [error, setError] = useState(null); // Handle errors
  const [searchQuery, setSearchQuery] = useState(""); // Store search query
  const [isDropdownVisible, setIsDropdownVisible] = useState(false); // Dropdown visibility
  const navigate = useNavigate();
  const token = localStorage.getItem("token"); // Retrieve token from localStorage
  const apiCalledRef = useRef(false);
  const cacheBuster = Date.now();
  const dropdownRef = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [trainerName, setTrainerName] = useState("");
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState([]);

  const fetchCourses = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/courses/?cacheBuster=${cacheBuster}&name=&published=true`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          setError("Unauthorized. Redirecting to login...");
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
      } else {
        const data = await response.json();
        setCourses(data || []);
        setFilteredCourses(data || []); // Set initial filtered data
      }
    } catch (err) {
      setError(err.message);
    }
  };


  useEffect(() => {
    if (!token) {
      setError("No token found, redirecting to login...");
      navigate("/login");
      return;
    }

    if (!apiCalledRef.current) {
      apiCalledRef.current = true;
      fetchCourses();
    }
  }, [token, navigate]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() === "") {
      setFilteredCourses(courses);
    } else {
      setFilteredCourses(
        courses.filter((course) =>
          course.name.toLowerCase().includes(query.toLowerCase())
        )
      );
    }
  };

  const handleFocus = () => {
    setIsDropdownVisible(true);
  };

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOpenModal = async (courseId) => {
    setIsModalOpen(false);


    const url = `${process.env.REACT_APP_API_BASE_URL}/coursebase/language/version/?base_course_id=${courseId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Token ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.detail === "No data found for the given base_course_id.") {
          navigate(`/course-details/${courseId}`); // Redirect user to subscription page

          return;
        }
      }

      if (data?.language_versions && Array.isArray(data.language_versions)) {
        setLanguages(data.language_versions);
        setSelectedLanguage(data.language_versions[0]?.language_name || "");
      }

      const allNull = data.language_versions.every(item => item.last_completed_course_item === null);
      if (allNull) {
        setTimeout(() => setIsModalOpen(true), 100); // ✅ Fix: Delay to ensure state update
      } else {
        const selectedLangObj = data.language_versions.find(lang => lang.last_completed_course_item !== null);
        if (selectedLangObj) {
          navigate(`/course-details/${selectedLangObj.id}`, { state: { trainerName } });
        } else {
          setTimeout(() => setIsModalOpen(true), 100); // ✅ Fix
        }
      }
    } catch (error) {
      toast.error("Something went wrong, Please try again later.", error);
    }
  };



  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirm = () => {
    if (!selectedLanguage) return;
    const selectedLangObj = languages.find(lang => lang.language_name === selectedLanguage);
    if (selectedLangObj) {
      navigate(`/course-details/${selectedLangObj.id}`, { state: { trainerName } });
    }
    handleCloseModal();
  };


  const renderHeaderCourseSearch = () => (
    <div className="header-course-search">
      <div className="course-search-data">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Course Search"
            value={searchQuery}
            onChange={handleSearch}
            onFocus={handleFocus}
            className="w-full p-2 border rounded mb-2 input-with-icon"
          />

          <i
            onClick={toggleDropdown}
            className={`fas ${isDropdownVisible ? "fa-chevron-up" : "fa-chevron-down"
              } search-icon`}
            role="button"
            aria-expanded={isDropdownVisible}
            aria-label="Toggle Dropdown"
          ></i>
        </div>
        {isDropdownVisible && (
          <div className="course-dropdown w-full border rounded">
            {filteredCourses.length > 0 ? (
              <div className="option-div">
                {filteredCourses.map((course) => (
                  <div
                    key={course.id}
                    className="option-values"
                    onClick={() => handleOpenModal(course.id)}
                  >
                    {course.name}
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-results">No results found</div>
            )}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div>
      {renderHeaderCourseSearch()}

      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 10,
          p: 4,
          borderRadius: 2,
        }}>
          <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.5rem", mb: 2 }}>
            Select Language
          </Typography>

          <FormControl fullWidth>
            <Select value={selectedLanguage} onChange={(e) => setSelectedLanguage(e.target.value)}>
              {languages.map((lang) => (
                <MenuItem key={lang.id} value={lang.language_name}>
                  {lang.language_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="contained" onClick={handleConfirm} sx={{ bgcolor: "green", color: "white" }}>
              Confirm
            </Button>
            <Button variant="contained" onClick={handleCloseModal} sx={{ bgcolor: "red", color: "white" }}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

    </div>
  );
};

export default HeaderCourse;
